import axios, { type AxiosResponse } from 'axios';
import flyd from 'flyd';
import { isEmpty } from '../utils';

const bearerToken = flyd.stream(localStorage.getItem('bearerToken') || '');
const refreshToken = flyd.stream(localStorage.getItem('refreshToken') || '');
const userEmailAddress = flyd.stream(localStorage.getItem('userEmail') || '');

async function register(
	email: string,
	zip: string,
	companyName: string,
	companyType: string,
	firstName: string,
	lastName: string,
	recaptchav2: string,
	recaptchav3: string
) {
	const payload = {
		emailAddress: email,
		companyZip: zip,
		companyName: companyName,
		companyType: companyType,
		firstName: firstName,
		lastName: lastName,
		recaptchaToken: recaptchav2,
		recaptchaResponseCode: recaptchav3,
	};

	return axios.post('/api/user', payload, { headers: { 'Content-Type': 'application/json' } }).then(
		async res => {
			await requestLogin(email, recaptchav2);
			return res.status;
		},
		err => Promise.reject(err)
	);
}

async function requestLogin(email: string, recaptcha: string) {
	const payload = { emailAddress: email, recaptchaToken: recaptcha };

	await axios
		.post('/api/login', payload, {
			headers: { 'Content-Type': 'application/json' },
		})
		.then(
			_ => {
				userEmailAddress(email);
				localStorage.setItem('userEmail', email);
			},
			err => Promise.reject(err)
		);
}

async function login(pin: string) {
	const grantType = 'password';
	const username = userEmailAddress();
	const password = pin;
	const payload = `grant_type=${grantType}&username=${username}&password=${password}`;

	await axios
		.post('/token', payload, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			withCredentials: true,
		})
		.then(handleAuthResponse, err => Promise.reject(err));
}

async function refreshTokens() {
	const grantType = 'refresh_token';
	const payload = `grant_type=${grantType}&refresh_token=${refreshToken()}`;

	await axios
		.post('/token', payload, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			withCredentials: true,
		})
		.then(handleAuthResponse, err => Promise.reject(err));
}

function logout() {
	bearerToken('');
	localStorage.removeItem('bearerToken');

	refreshToken('');
	localStorage.removeItem('refreshToken');

	userEmailAddress('');
	localStorage.removeItem('userEmail');
}

function isAuth() {
	return flyd.map(n => !isEmpty(n), bearerToken);
}

function handleAuthResponse(res: AxiosResponse<any>): void {
	bearerToken(res.data.access_token);
	localStorage.setItem('bearerToken', bearerToken());

	refreshToken(res.data.refresh_token);
	localStorage.setItem('refreshToken', refreshToken());
}

export const AuthService = {
	bearerToken,
	refreshToken,
	userEmailAddress,
	register,
	requestLogin,
	login,
	refreshTokens,
	logout,
	isAuth,
	handleAuthResponse,
};
